import { useRef } from "react"; // Removed useEffect, useState if not used elsewhere
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Input, Row, Col, Card, CardBody, Button, Spinner } from "reactstrap";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from "date-fns";


const AddCourseModuleForm = ({
    labels,
    formikProps,
    isAddOrEdit,
    onTranslateClickHandler,
    translationLoading,
    lastTranslatedField,
    currentModuleId,
}) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === "rtl";

    const { values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched } = formikProps;

    const today = new Date().toISOString().split("T")[0];

    const { Users, Course, CourseModules, topicsList } = useSelector((state) => ({
        Users: state.Users.users,
        Course: state.CourseModules.course,
        CourseModules: state.CourseModules.modules,
        topicsList: state.Topics.topicsList,
    }));

    const renderField = (item) => {
        const fieldName = item.name;
        const fieldValue = values[fieldName] ?? '';
        const isDisabled = typeof item.disabled === 'function' ? item.disabled(isAddOrEdit, values) : !!item.disabled;

        switch (item.fieldName) {
            // ... other cases ...

            case 'text-box-translate':
            case 'textarea-translate':
                const InputComponent = item.fieldName === 'textarea-translate' || item.isTextArea ? 'textarea' : 'text';
                return (
                    <div className={`input-group ${isRTL ? 'rtl-input-group' : ''}`}>
                        <Input
                            type={InputComponent === 'textarea' ? 'textarea' : 'text'}
                            rows={item.fieldName === 'textarea-translate' || item.isTextArea ? (item.rows || "2") : undefined}
                            id={fieldName}
                            name={fieldName}
                            placeholder={t(item.placeholder || item.labelName)}
                            value={fieldValue}
                            onChange={handleChange}
                            maxLength={item.maxLength} 
                            minLength={item.minLength}
                            onBlur={handleBlur} // Standard onBlur for simple inputs
                            className="form-control"
                            invalid={touched[fieldName] && !!errors[fieldName]}
                            disabled={isDisabled}
                            required={item.required}
                        />
                       {onTranslateClickHandler && item.translateTo && (
                        <Button
                            type="button"
                            onClick={() => onTranslateClickHandler(item.translateTo, fieldValue, setFieldValue, item.name)}
                            disabled={!fieldValue || !fieldValue.trim() || translationLoading}
                        >
                            {translationLoading && lastTranslatedField === item.name ? (
                            <Spinner size="sm" />
                            ) : (
                            <i className="ri-translate"></i>
                            )}
                        </Button>
                       )}
                    </div>
                );

            case 'text-box':
                return (
                    <Input
                        type="text"
                        id={fieldName}
                        name={fieldName}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue}
                        onChange={handleChange}
                        maxLength={item.maxLength} 
                        minLength={item.minLength}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    />
                );

            case 'textarea-box':
                return (
                    <Input
                        type="textarea"
                        rows={item.rows || "2"}
                        id={fieldName}
                        name={fieldName}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    />
                );

            case 'number-box':
                return (
                    <Input
                        type="text"
                        style={{ textAlign: isRTL ? 'right' : 'left' }}
                        id={fieldName}
                        name={fieldName}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue}
                        onChange={(e) => {
                            const inputValue = e.target.value;
                            let filteredValue = inputValue.replace(/[^0-9.]/g, '');

                            const parts = filteredValue.split('.');
                            if (parts.length > 2) {
                                filteredValue = parts[0] + '.' + parts.slice(1).join('');
                            }
                            setFieldValue(fieldName, filteredValue);
                        }}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    />
                );

            case 'date':
                return (
                    <Input
                        type="date"
                        id={fieldName}
                        name={fieldName}
                        min={item.minToday ? today : (item.minDateFromCourse && Course?.StartDate ? (Course.StartDate || '').split('T')[0] : item.min)}
                        max={item.max}
                        value={(fieldValue || '').split('T')[0]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    />
                );

            // case 'date-picker':
            //     const isInvalidDatePicker = touched[fieldName] && !!errors[fieldName];
            //     return (
            //         <DatePicker
            //             ref={datePickerRef} 
            //             key={`${fieldName}-${values.ID || 'new'}`} 
            //             inputClass={isInvalidDatePicker ? "form-control is-invalid" : "form-control"}
            //             multiple={false}
            //             value={fieldValue ? new Date(fieldValue) : null}
            //             onChange={(dateObject) => {
            //                 // Date parsing logic from your code
            //                 let parsedDate = null;
            //                 if (!dateObject) {
            //                     parsedDate = null;
            //                 } else if (typeof dateObject === "string") {
            //                     const tryParse = new Date(dateObject);
            //                     if (!isNaN(tryParse)) {
            //                         parsedDate = tryParse;
            //                     }
            //                 } else if (dateObject instanceof Date || typeof dateObject.toDate === 'function') {
            //                     parsedDate = dateObject.toDate ? dateObject.toDate() : dateObject;
            //                 }

            //                 const isoDate = parsedDate ? new Date(parsedDate).toISOString().split("T")[0] : null;
            //                 setFieldValue(fieldName, isoDate, true);
            //                 // Explicitly request validation after setting touched state as well
            //                 setFieldTouched(fieldName, true, true); 
            //             }}
            //             onClose={() => {
            //                 setFieldTouched(fieldName, true, true);
            //             }}
            //             mapDays={({ date }) => {
            //                 if (!Course || !Course.Days || !Array.isArray(Course.Days)) return {};

            //                 const dateStr = date.toDate().toISOString().slice(0, 10);
            //                 const currentDayIndex = date.weekDay.index; // 0 (Sun) to 6 (Sat)

            //                 const allowedCourseDaysIndexes = Course.Days.map((dayId) => {
            //                     const numericDayId = Number(dayId);
            //                     if (isNaN(numericDayId)) return -1;
            //                     return numericDayId % 7;
            //                 }).filter(index => index >= 0 && index <= 6);

            //                 if (!allowedCourseDaysIndexes.includes(currentDayIndex)) {
            //                     return {
            //                         disabled: true,
            //                         className: "disabled-date-course-day", 
            //                         style: { color: "#aaa" }
            //                     };
            //                 }

            //                 const usedDates = (CourseModules || [])
            //                     .filter(mod => !(currentModuleId && mod.ID === currentModuleId))
            //                     .map(mod => mod.StartDate ? new Date(mod.StartDate).toISOString().slice(0, 10) : null)
            //                     .filter(Boolean);

            //                 if (usedDates.includes(dateStr)) {
            //                     return {
            //                         disabled: true,
            //                         className: "disabled-date-used-module", // Custom class
            //                         style: { color: "#aaa", textDecoration: "line-through" } // Example
            //                     };
            //                 }
            //                 return {};
            //             }}
            //             format={item.format || "MMM D, YYYY"}
            //             placeholder={t(item.placeholder || "SelectDate")}
            //             minDate={Course?.StartDate
            //                 ? new Date(new Date(Course.StartDate).setHours(0, 0, 0, 0))
            //                 : new Date(new Date().setHours(0,0,0,0))}
            //             disabled={isDisabled}
            //             // The 'required' attribute is for native HTML validation.
            //             // Formik handles validation via its schema.
            //         />
            //     );

            case 'date-picker':
                const isInvalidDate = touched[fieldName] && !!errors[fieldName];
                const parsedDate = fieldValue ? new Date(fieldValue) : null;

                // Calculate minDate for validation                
                const minDate =  Course?.StartDate ? new Date(Course.StartDate): null;

                // Dates already used by other modules
                const usedDates = (CourseModules || [])
                    .filter(mod => !(currentModuleId && mod.ID === currentModuleId))
                    .map(mod => mod.StartDate ? new Date(mod.StartDate).toDateString() : null)
                    .filter(Boolean);

                // Allowed weekdays from Course.Days
                const allowedWeekdays = (Course?.Days || []).map((dayId) => Number(dayId) % 7);

                return (
                    <div dir={isRTL ? 'rtl' : 'ltr'}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                value={parsedDate}
                                format="dd/MM/yyyy" 
                                onChange={(newValue) => {
                                    // newValue is a Date object or null from MUI DatePicker
                                    // const isoDate = newValue ? new Date(newValue).toISOString().split("T")[0] : null;
                                    // setFieldValue(fieldName, isoDate);
                                    const formattedDate = newValue ? format(newValue, 'yyyy-MM-dd') : null;
                                    setFieldValue(fieldName, formattedDate);
                                }}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        error: isInvalidDate,
                                        helperText: isInvalidDate ? t(errors[fieldName]) : '',
                                        required: item.required,
                                        disabled: isDisabled,
                                        inputProps: {
                                            readOnly: true,  
                                        }
                                    }
                                }}
                                disablePast={minDate}
                                minDate={minDate}
                                shouldDisableDate={(date) => {
                                    const weekday = date.getDay(); 
                                    const dateStr = date.toDateString();

                                    if (allowedWeekdays.length && !allowedWeekdays.includes(weekday)) return true;
                                    if (usedDates.includes(dateStr)) return true;
                                    return false;
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                );


            case 'tutor-dropdown':
                return (
                    <Input
                        type="select"
                        id={fieldName}
                        name={fieldName}
                        value={fieldValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    >
                        <option value="">{t(item.defaultOptionLabel || "Choose")}</option>
                        {(Users || []).map((option) => (
                            <option key={option.Id} value={option.Id.toString()}>
                                {option.FullName}
                            </option>
                        ))}
                    </Input>
                );

            case 'topic-dropdown':
                return (
                    <Input
                        type="select"
                        id={fieldName}
                        name={fieldName}
                        value={fieldValue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="form-control"
                        invalid={touched[fieldName] && !!errors[fieldName]}
                        disabled={isDisabled}
                        required={item.required}
                    >
                        <option value="">{t("Choose")}</option>
                        {(topicsList || []).map(topic => (
                            <option key={topic.ID} value={topic.ID.toString()}>
                                {i18n.language === 'en' ? topic.TopicNameEn : topic.TopicNameAr}
                            </option>
                        ))}
                    </Input>
                );

            default:
                return <p>Unsupported field type: {item.fieldName}</p>;
        }
    };

    return (
        <Row>
            {labels.map((item) => {
                const fieldName = item.name;
                const showLabel = item.fieldName !== 'check-box' || !item.noMainLabel;

                return (
                    <Col sm={item.colSize || 6} key={fieldName} className={item.className}>
                        <div className="mb-3">
                            {showLabel && (
                                <label htmlFor={fieldName} className="col-form-label">
                                    {t(item.labelName)}
                                    {item.required && <span className="text-danger"> *</span>}
                                </label>
                            )}
                            {renderField(item)}
                            {touched[fieldName] && errors[fieldName] && (
                                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
                                    {typeof errors[fieldName] === 'string' ? t(errors[fieldName]) : errors[fieldName]}
                                </div>
                            )}
                        </div>
                    </Col>
                );
            })}
        </Row>
    );
};

export default AddCourseModuleForm;